import { useRegisterSW } from 'virtual:pwa-register/vue'
import { ref } from 'vue'

export function usePWA() {
  const offlineReady = ref(false)
  const needRefresh = ref(false)
  const updateError = ref<Error | null>(null)

  const { updateServiceWorker } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl: string, registration: ServiceWorkerRegistration | undefined) {
      console.log('[PWA] Service Worker registrado:', swUrl)

      // Verificar actualizaciones periódicamente (cada 60 segundos)
      if (registration) {
        setInterval(() => {
          registration.update()
          console.log('[PWA] Verificando actualizaciones...')
        }, 60 * 1000)
      }
    },
    onRegisterError(error: Error) {
      console.error('[PWA] Error al registrar SW:', error)
      updateError.value = error
    },
    async onNeedRefresh() {
      console.log('[PWA] Nueva versión disponible')

      // Fetch config desde el servidor para saber el modo actual
      try {
        const response = await fetch('/update-config.json?' + Date.now())
        const config = await response.json()

        if (config.mode === 'auto') {
          console.log('[PWA] Modo auto: actualizando automáticamente...')
          await updateServiceWorker(true)
          setTimeout(() => window.location.reload(), 1000)
        } else {
          // Modo prompt: mostrar notificación al usuario
          console.log('[PWA] Modo prompt: esperando acción del usuario...')
          needRefresh.value = true
        }
      } catch (err) {
        // Si falla obtener config, mostrar prompt por defecto
        console.warn('[PWA] No se pudo obtener config, usando modo prompt por defecto')
        needRefresh.value = true
      }
    },
    onOfflineReady() {
      console.log('[PWA] App lista para uso offline')
      offlineReady.value = true
    }
  })

  const updateApp = async () => {
    console.log('[PWA] Actualizando aplicación...')
    try {
      await updateServiceWorker(true)
      setTimeout(() => {
        console.log('[PWA] Forzando recarga de página...')
        window.location.reload()
      }, 1000)
    } catch (error) {
      console.error('[PWA] Error al actualizar:', error)
      window.location.reload()
    }
  }

  const dismissUpdate = () => {
    needRefresh.value = false
  }

  const dismissOfflineReady = () => {
    offlineReady.value = false
  }

  return {
    offlineReady,
    needRefresh,
    updateError,
    updateApp,
    dismissUpdate,
    dismissOfflineReady
  }
}



